import AvatarSvg from '../../../assets/avatar.svg?react';
import { IconProps } from '../../types/IconProps';

export function Avatar({ size = 20, ...props }: IconProps) {
  return <AvatarSvg data-testid="avatar-icon" width={size} height={size} {...props} />;
}

export default Avatar;
